import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// SPA anchor handling: on load or route change, scroll to the URL hash once
// the target exists; plain route changes reset to the top.
function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "auto"
        : "smooth";
      requestAnimationFrame(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior, block: "start" });
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

export default ScrollToHash;
